import React, { Suspense, useEffect } from "react"
import { useParams } from "react-router-dom"
import { useAppDependencies } from "../../context/AppContext"
import LandingPage from "../search/LandingPage"
import ContactUsPage from "../general/ContactUsPage"
import TermsPage from "../general/TermsPage"
import HowItWorksPage from "../general/HowItWorksPage"
import PrivacyPolicyPage from "../general/PrivacyPolicyPage"
import CookiePolicyPage from "../general/CookiePolicyPage"
import DataProtectionPage from "../general/DataProtectionPage"
import LandingChrome from "../search/LandingChrome"
import "../areas/AreaDetail.css"
import "../valuations/SavedValuationsPageOverrides.css"
import OldUrlRedirect from "./OldUrlRedirect"
import StateConstants from "../../states/StateContstants"
import PlanModal from "../premium/PlanModal"
import LoginModal from "../login/LoginModal"

// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const SavedValuationsPage = React.lazy(() => import("../valuations/SavedValuationsPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const ReportsListingPage = React.lazy(() => import("../reports/ReportsListingPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const ReportPage = React.lazy(() => import("../reports/ReportPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const MagicLinkPage = React.lazy(() => import("../reports/MagicLinkPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const ValuationPageServer = React.lazy(() => import("../valuations/ValuationPageServer"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const AreaSearchPage = React.lazy(() => import("../search/AreaSearchPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const AreaAnalysisPageServer = React.lazy(() => import("../areas/AreaAnalysisPageServer"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const PremiumPage = React.lazy(() => import("../premium/PremiumPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const AccountPage = React.lazy(() => import("../account/AccountPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const AnalysisDashboardPage = React.lazy(() => import("../analysis/AnalysisDashboardPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const AnalysisValuationPage = React.lazy(() => import("../analysis/AnalysisValuationPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const HomeownerReportPage = React.lazy(() => import("../homeowner-report/HomeownerReportPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const ReportIntakePage = React.lazy(() => import("../homeowner-report/ReportIntakePage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const SampleReportPage = React.lazy(() => import("../homeowner-report/SampleReportPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const RefinedReportPage = React.lazy(() => import("../analysis/RefinedReportPage"))
// @ts-expect-error Node16 moduleResolution requires .js but webpack resolves .tsx
const ReportPreviewPage = React.lazy(() => import("../analysis/ReportPreviewPage"))

// Login Page — opens modal on top of landing page instead of dedicated page
export function LoginPageWrapper() {
    const deps = useAppDependencies()
    useEffect(() => {
        deps.stateHandler.set(StateConstants.SHOW_LOGIN_MODAL, true)
    }, [deps.stateHandler])

    return (
        <>
            <LandingPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                loginHelper={deps.loginHelper}
               
            />
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </>
    )
}

export function ContactPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <div className="contact-next">
                <ContactUsPage />
            </div>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function HowItWorksPageWrapper() {
    const deps = useAppDependencies()
    return (
        <>
            <HowItWorksPage stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} />
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </>
    )
}

export function TermsPageWrapper() {
    const deps = useAppDependencies()
    return (
        <>
            <TermsPage stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} />
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </>
    )
}

export function PrivacyPolicyPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <div className="contact-next">
                <PrivacyPolicyPage />
            </div>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function CookiePolicyPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <div className="contact-next">
                <CookiePolicyPage />
            </div>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function DataProtectionPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <div className="contact-next">
                <DataProtectionPage />
            </div>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function SavedValuationsPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
            <div className="saved-next">
                <SavedValuationsPage
                    apiHandler={deps.apiHandler}
                    stateHandler={deps.stateHandler}
                    errorHandler={deps.errorHandler}
                    loader={deps.loader}
                    loginHelper={deps.loginHelper}
                />
            </div>
            </Suspense>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function ReportsListingPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <ReportsListingPage apiHandler={deps.apiHandler} stateHandler={deps.stateHandler} />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function ReportPageWrapper() {
    const deps = useAppDependencies()
    const { reportId } = useParams()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <ReportPage reportId={reportId || ""} apiHandler={deps.apiHandler} stateHandler={deps.stateHandler} featureProvider={deps.featureProvider} />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function MagicLinkPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <MagicLinkPage apiHandler={deps.apiHandler} loginHelper={deps.loginHelper} stateHandler={deps.stateHandler} />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function AnalysisValuationPageWrapper() {
    const deps = useAppDependencies()
    const { refinedValuationId } = useParams()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <AnalysisValuationPage
                    refinedValuationId={refinedValuationId || ""}
                    apiHandler={deps.apiHandler}
                    stateHandler={deps.stateHandler}
                    googleMapsApiKey={deps.config.deploymentEnvironmentConfig.get("GOOGLE_MAPS_JS_API_KEY")}
                />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function RefinedReportPageWrapper() {
    const deps = useAppDependencies()
    const { refinedValuationId } = useParams()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <RefinedReportPage
                    refinedValuationId={refinedValuationId || ""}
                    apiHandler={deps.apiHandler}
                    stateHandler={deps.stateHandler}
                />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function ReportPreviewPageWrapper() {
    const deps = useAppDependencies()
    const { refinedValuationId } = useParams()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <ReportPreviewPage
                    refinedValuationId={refinedValuationId || ""}
                    apiHandler={deps.apiHandler}
                    stateHandler={deps.stateHandler}
                    featureProvider={deps.featureProvider}
                />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function AnalysisDashboardPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <AnalysisDashboardPage apiHandler={deps.apiHandler} stateHandler={deps.stateHandler} />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function AreaSearchPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
            <AreaSearchPage
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                loginHelper={deps.loginHelper}
            />
            </Suspense>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function AreaAnalysisPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
            <div className="area-detail-next">
                <AreaAnalysisPageServer
                    stateHandler={deps.stateHandler}
                    apiHandler={deps.apiHandler}
                    errorHandler={deps.errorHandler}
                    loader={deps.loader}
                    areaAnalysisBuilderChain={deps.areaAnalysisBuilderChain}
                    featureProvider={deps.featureProvider}
                />
            </div>
            </Suspense>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function ValuationPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
            <ValuationPageServer
                stateHandler={deps.stateHandler}
                apiHandler={deps.apiHandler}
                errorHandler={deps.errorHandler}
                loader={deps.loader}
                loginHelper={deps.loginHelper}
                featureProvider={deps.featureProvider}
               
                googleMapsApiKey={deps.config.deploymentEnvironmentConfig.get("GOOGLE_MAPS_JS_API_KEY")}
            />
            </Suspense>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function ValuationPageWithoutSlugWrapper() {
    return <ValuationPageWrapper />
}

export function PremiumPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
            <div className="premium-next">
                <PremiumPage
                    stateHandler={deps.stateHandler}
                    apiHandler={deps.apiHandler}
                />
            </div>
            </Suspense>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function AccountPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <AccountPage apiHandler={deps.apiHandler} stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} />
            </Suspense>
            <PlanModal stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function OldUrlRedirectWrapper() {
    return <OldUrlRedirect />
}

export function HomeownerReportPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <HomeownerReportPage stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function ReportIntakePageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <ReportIntakePage stateHandler={deps.stateHandler} apiHandler={deps.apiHandler} />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}

export function SampleReportPageWrapper() {
    const deps = useAppDependencies()
    return (
        <LandingChrome stateHandler={deps.stateHandler} loginHelper={deps.loginHelper}>
            <Suspense fallback={null}>
                <SampleReportPage apiHandler={deps.apiHandler} />
            </Suspense>
            <LoginModal stateHandler={deps.stateHandler} loginHelper={deps.loginHelper} apiHandler={deps.apiHandler} />
        </LandingChrome>
    )
}
